import Marquee from "react-fast-marquee";
import { Reveal } from "./Reveal";
import { CLIENT_WORDS, CLIENTS } from "../data/content";

export default function Story() {
  return (
    <section id="story" data-testid="story-section" className="bg-[#F9F9F6] text-[#0A0A0A] py-28 md:py-36">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid lg:grid-cols-12 gap-12 items-start">
          <Reveal className="lg:col-span-5">
            <div className="relative aspect-[4/5] overflow-hidden rounded-b-[160px] vignette border border-[#0A0A0A]/10">
              <img src="/assets/team.jpg" alt="The Novaphi Catering team" data-testid="story-image" className="w-full h-full object-cover" />
            </div>
            <p className="text-[10px] uppercase tracking-[0.25em] text-[#0A0A0A]/40 mt-4">The Novaphi team — serving moments, creating memories</p>
          </Reveal>
          <div className="lg:col-span-7 lg:pt-10">
            <Reveal>
              <p className="text-xs uppercase tracking-[0.3em] text-[#998100] mb-4">Our Story</p>
              <h2 className="font-serif-e text-4xl md:text-5xl lg:text-6xl tracking-tight leading-tight">
                A women-powered brand, built on beautiful experiences.
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="text-[#0A0A0A]/70 text-base md:text-lg leading-relaxed mt-8 max-w-2xl">
                Novaphi is a growing South African brand built on entrepreneurship, service excellence and a passion for creating beautiful experiences through food. From intimate gatherings to corporate functions of ±150 guests, our growth has been driven by what clients actually need: good food, dependable execution, professional communication and presentation that makes an impression.
              </p>
            </Reveal>
            <Reveal delay={0.2}>
              <div className="grid sm:grid-cols-3 gap-px bg-[#0A0A0A]/10 border border-[#0A0A0A]/10 mt-12">
                {[
                  ["150+", "Guests at our largest events"],
                  ["2–20", "Guests per grazing board"],
                  ["7", "Catering specialities"],
                ].map(([n, label]) => (
                  <div key={label} className="bg-[#F9F9F6] p-6">
                    <p className="font-serif-e text-4xl text-[#998100]">{n}</p>
                    <p className="text-[11px] uppercase tracking-[0.15em] text-[#0A0A0A]/50 mt-2">{label}</p>
                  </div>
                ))}
              </div>
            </Reveal>
            <Reveal delay={0.3}>
              <blockquote className="mt-12 border-l-2 border-[#D4AF37] pl-6">
                <p className="font-serif-e italic text-2xl md:text-3xl leading-snug text-[#0A0A0A]">
                  “We are proud of the women behind the Novaphi Catering brand.”
                </p>
                <cite className="not-italic text-[11px] uppercase tracking-[0.2em] text-[#0A0A0A]/50 mt-3 block">The Novaphi Team</cite>
              </blockquote>
            </Reveal>
          </div>
        </div>
      </div>
      <div className="mt-24 border-t border-[#0A0A0A]/10 pt-16" data-testid="clients-strip">
        <p className="text-center text-[10px] uppercase tracking-[0.3em] text-[#0A0A0A]/40 mb-10">Proudly trusted by</p>
        <div className="flex flex-wrap items-center justify-center gap-10 md:gap-20 max-w-4xl mx-auto px-6">
          {CLIENTS.map((c) => (
            <div key={c.name} data-testid={`client-logo-${c.name.toLowerCase().replace(/[^a-z]+/g, "-")}`} className="flex flex-col items-center gap-3 group">
              <img src={c.logo} alt={`${c.name} logo`} className="h-14 md:h-16 w-auto object-contain grayscale group-hover:grayscale-0 transition-[filter] duration-500" />
              <p className="text-[10px] uppercase tracking-[0.2em] text-[#0A0A0A]/50">{c.name}</p>
            </div>
          ))}
        </div>
      </div>
      <div className="mt-14 border-y border-[#0A0A0A]/10 py-6">
        <Marquee speed={45} gradient={false}>
          {CLIENT_WORDS.concat(CLIENT_WORDS).map((w, i) => (
            <span key={i} className="font-serif-e text-xl md:text-2xl text-[#0A0A0A]/60 mx-10 whitespace-nowrap">
              {w} <span className="text-[#D4AF37] ml-10">·</span>
            </span>
          ))}
        </Marquee>
      </div>
    </section>
  );
}
